<template>
  <div
    class="floating-popup-message"
    :class="{ hide: hide }"
  >
    <div class="header">
      <img
        class="signInLogo paddingNormalTop paddingLargeBottom"
        src="/images/dark-logo.svg"
        alt="Leland Little Auctions"
      >
    </div>
    <div
      v-if="title"
      class="popupTitle"
      v-html="title"
    />
    <p
      class="textCenter"
      v-html="message"
    />
    <div class="flexBox flexBoxSpread noWrap">
      <div v-if="confirmLabel">
        <button
          @click="confirm"
          v-html="confirmLabel"
        />
      </div>
      <div v-if="cancelLabel">
        <button @click="cancel">
          {{ cancelLabel }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>

/**
 * The PopupMessage Component
 * @displayName Popup Message
 */
export default {
  name: 'PopupMessage',
  components: {},
  props: ['title', 'message', 'confirmLabel', 'cancelLabel'],
  data () {
    return {
      doNotShowAgain: false,
      hide: false
    }
  },
  computed: {},
  mounted () {},
  methods: {
    /**
     * Gets called when user clicks Do Not Show Again checkbox.
     *
     * @public
     * @deprecated
     */
    toggleDoNotShowAgain: function () {
      this.doNotShowAgain = !this.doNotShowAgain
    },
    /**
     * Close event.
     *
     * @event close
     * @public
     */
    close: function () {
      this.hide = true
      this.$emit('close', {
        doNotShowAgain: this.doNotShowAgain
      })
    },
    /**
     * Cancel event.
     *
     * @event cancel
     * @public
     */
    cancel: function () {
      this.hide = true
      this.$emit('cancel', {
        doNotShowAgain: this.doNotShowAgain
      })
    },
    /**
     * Confirm event.
     *
     * @event confirm
     * @public
     */
    confirm: function () {
      // this.hide = true
      this.$emit('confirm', {
        doNotShowAgain: this.doNotShowAgain
      })
    }
  }
}
</script>

<style scoped></style>
